import LeftSideBar from "./LeftSideBar";
import Topbar from "./Topbar";
import { DeccaContext } from "../../StateManagment/DeccaContext.js";
import { useContext } from "react";
import Sidebar from "../AI/decca/Sidebar";
import TOCProgressBanner from "../onboarding/TOCProgressBanner";
import OnboardingResumeBanner from "../onboarding/OnboardingResumeBanner";
import useDocumentBranding from "../../hooks/useDocumentBranding";

const Layout = ({ children }) => {
  const { deccaState } = useContext(DeccaContext);
  useDocumentBranding();

  // 'closed' rendert niets. Alleen 'sidebar' en 'fullscreen' worden door Layout
  // zelf gemount.
  const showSidebarHere = deccaState === "sidebar" || deccaState === "fullscreen";

  return (
    <div id="main-decca-container">
      {/* 1) Left column */}
      <div id="layout-left-column">
        <LeftSideBar />
      </div>

      {/* 2) Middle column */}
      <div id="layout-middle-column">
        <OnboardingResumeBanner />
        <TOCProgressBanner />
        <Topbar />
        <div id="page-container">
          {children}
        </div>
      </div>

      {/* 3) Right column */}
      {showSidebarHere && <Sidebar />}
    </div>
  );
};

export default Layout;
